import ReactOnRails from 'react-on-rails/client';
import ConsumerApp from './consumer-bundle.imports-loadable';

ReactOnRails.register({
  ConsumerApp,
});
